import { useCart, usePrevious } from 'lib/core/hooks'
import { useEffect } from 'react'
import { useListrakReady } from '../useListrakReady'
import { useStoreView } from 'hooks/useStoreView'

const win: any = window

export const useListrakCartActivity = () => {
  const { count, cart, isFirstLoad, cartId } = useCart()
  const { isLoaded } = useListrakReady()
  const prevCount = usePrevious(isFirstLoad ? undefined : count)
  const { isSofiaAndGrace } = useStoreView()

  useEffect(() => {
    if (isSofiaAndGrace) {
      try {
        const SCA = win._ltk?.SCA

        if (count > 0) {
          // eslint-disable-next-line
          console.group('Listrak >>', 'Cart')

          cart?.data?.items.forEach(cartItem => {
            const product = cartItem.variantProduct ?? cartItem.product
            const imageUrl = product.image?.default.url ?? product.image?.default
            // eslint-disable-next-line
            console.info('Listrak >>', '_ltk.SCA.AddItemWithLinks()', [
              product.sku,
              cartItem.quantity,
              `${cartItem.prices.price.value}`,
              product.name,
              imageUrl,
              `/${product.urlKey}`
            ])

            SCA?.AddItemWithLinks(
              product.sku,
              cartItem.quantity,
              `${cartItem.prices.price.value}`,
              product.name,
              imageUrl,
              `/${product.urlKey}`
            )
          })

          if (SCA) {
            SCA.CartLink = `${window.location.protocol}//${window.location.hostname}/cart/${cartId}`
          }

          // eslint-disable-next-line
          console.info('Listrak >>', '_ltk.SCA.Submit()')
          SCA?.Submit()

          // eslint-disable-next-line
          console.groupEnd()
        }

        if (prevCount && count === 0) {
          // eslint-disable-next-line
          console.group('Listrak >>', 'Cart')

          // eslint-disable-next-line
          console.info('Listrak >>', '_ltk.SCA.ClearCart()')
          SCA.ClearCart()

          // eslint-disable-next-line
          console.info('Listrak >>', '_ltk.SCA.Submit()')
          SCA?.Submit()

          // eslint-disable-next-line
          console.groupEnd()
        }
      } catch (e) {
        // eslint-disable-next-line
        console.log('Listrak Error >>', e.message)
      }
    }
    // eslint-disable-next-line
  }, [count, isLoaded, isSofiaAndGrace])

  return null
}
